import RadioButton from "./button";
import RadioButtonGroup from "./group";

const Radio = {
    Button: RadioButton,
    Group: RadioButtonGroup
}

export default Radio;